<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl" />
        <div class="row">
        <div class="col-lg-12 col-sm-12 mb-3">
            <div class="card p-4">
                <div class="media">
                    <div class="avatar-sm mr-3">
                        <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                            <i class="bx bx-user-plus bx-md"></i>
                        </span>
                    </div>
                    <div class="media-body">
                        <h5 class="mt-3">{{ $t('twitter.twitter-search.add-new-twitter') }}</h5>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-8">
                        <h5 v-if="totalResult !== 0 ">{{ $t('twitter.twitter-search.total-results') }} : {{totalResult}}</h5>
                    </div>
                    <div class="col-sm-4 text-right">
                        <div class="input-group">
                            <input
                            id="search"
                            type="text"
                            class="form-control"
                            v-model="searchKey"
                            placeholder="Search .."
                            aria-describedby="search"
                            @keyup.enter="searchTwitter"
                            />
                            <div class="input-group-prepend">
                            <button
                                id="search"
                                class="input-group-text bg-primary text-white"
                                @click="searchTwitter"
                            >
                                <i class="bx bx-search-alt search-icon"></i>
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12  p-5 m-5 text-center" v-if="!search && searchResult == 0 && !dnf && !loading && error == ''">
                    ....
                    </div>
                      <div v-if="error !== '' && !loading" class="row mt-5 mb-5 p-5 mx-auto">
                        <div class="text-center">
                           <span class="text-danger">{{error}}</span>  
                        </div>
                    </div>
                    <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loading">
                      <div class="text-center loading">
                         <b-spinner label="Loading..."></b-spinner><br> Loading..
                      </div>
                    </div>
                     <div class="col-sm-12 p-5 mt-5 mb-5" v-if="!loading && dnf">
                      <div class="text-center loading mb-5">
                         {{$t('all.dnf')}}
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="!search || searchResult[0] && !loading">
                        <div class="row">
                            <div class="col-sm-4 col-md-4 mb-3" v-for="(result, index) in searchResult[0]" :key="index">
                                <div class="card p-3 h-100">
                                    <div class="row text-Secondary">
                                    <div class="col-sm-8">
                                        <div class="media mb-3">
                                        <div class="avatar-md mr-2">
                                            <img
                                            :src="result.avatar"
                                            class="mr-3 rounded-circle avatar-md"
                                            alt="user-pic"
                                            />
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mt-3">{{result.name}} <span v-if="result.verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span></h6>
                                            <p class="text-secondary">
                                            (<span class="mb-1">@{{result.screen_name}}</span>) &nbsp;   <span v-if="result.private == true" class="text-secondary"> <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i> </span>
                                            </p>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <router-link to="#">
                                            <b-button class="btn btn-sm" variant="primary" @click="addTwitter(result)">
                                                <!-- <div v-show="loading" class="spinner-border spinner-border-sm" role="status">
                                                </div>  -->
                                            {{ $t('twitter.twitter-search.add') }} </b-button>
                                        </router-link>
                                    </div>
                                    <div class="col-sm-6 mb-2">
                                        <h6>{{ $t('twitter.twitter-search.created-on') }}:</h6>
                                    </div>
                                    <div class="col-sm-6 mb-2 text-right">
                                        <span class="text-secondary">{{ formatDate(result.created)}}</span>
                                    </div>
                                    <div class="col-sm-6 mb-2">
                                        <h6>{{ $t('twitter.twitter-search.location') }}:</h6>
                                    </div>
                                    <div class="col-sm-6 mb-2 text-right">
                                        <span class="text-secondary">{{result.location}}</span>
                                    </div>
                                    <div class="col-sm-6 mb-2">
                                        <h6>{{ $t('twitter.twitter-search.tweets') }}:</h6>
                                    </div>
                                    <div class="col-sm-6 mb-2 text-right">
                                        <span class="text-secondary">{{result.tweets}}</span>
                                    </div>
                                    <div class="col-sm-6 mb-2">
                                        <h6>{{ $t('twitter.twitter-search.followers') }}:</h6>
                                    </div>
                                    <div class="col-sm-6 mb-2 text-right">
                                        <span class="text-secondary">{{result.followers}}</span>
                                    </div>
                                    <div class="col-sm-6 mb-2">
                                        <h6>{{ $t('twitter.twitter-search.following') }}:</h6>
                                    </div>
                                    <div class="col-sm-6 text-right">
                                        <span class="text-secondary">{{result.following}}</span>
                                    </div>
                                    <div class="col-sm-12 text-center">
                                        <hr />
                                        <a
                                        :href="'https://twitter.com/'+result.screen_name"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        ><b>{{ $t('twitter.twitter-search.see-profile') }}</b></a
                                        >
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import store from "@/state/store";
import moment from "moment";
import Particle from "./particle.vue";
import TwintService from "@/helpers/twint.service.js";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
import Vue from "vue";


import { tableData } from "./dataAdvancedtable";

export default {
    page: {
        title: "Tools Twitter",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Particle },
    data() {
        return {
        backUrl: "/twitter",
        loading:false,
        error:"",
        tableData: tableData,
        search: false,
        dnf: false,
        totalResult:0,
        searchKey: "",
        searchResult: [],
        title: this.$t('twitter.twitter-search.twitter-search'),
        items: [
            {
            text: "Dashboard",
            href: "/",
            },
            {
            text: "Twitter",
            href: "/twitter",
            },
            {
            text: this.$t('twitter.twitter-search.twitter-search'),
            active: true,
            },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "age",
        sortDesc: false,
        fields: [
            { key: "id", thClass: "d-none", tdClass: "d-none" },
            { key: "account", sortable: true },
            { key: "followers", sortable: true },
            { key: "following", sortable: true },
            { key: "post", sortable: true },
            { key: "status", sortable: true },
            { key: "actions", class: "text-center" },
        ],
        };
    },
    computed: {
        rows() {
        return this.tableData.length;
        },
    },
    methods: {
        searchTwitter() {
        this.error = "",
        this.totalResult = 0;
        this.dnf = false
        const data = {
            query: this.searchKey,
        };
        if (this.searchKey != "") { 
            this.loading = true;
            this.search = true;
            this.searchResult = []
            TwintService.search(data)
            .then((response) => {
                // Menyesuaikan dengan struktur response API baru
                const users = response.data.data.users || [];
                this.searchResult.push(users)
                this.totalResult = response.data.data.metadata.result_count || users.length
                let total = users.length;
                if(total == 0){
                    this.dnf = true;
                }
                this.search = false;
                this.loading = false;
            })
            .catch((err) => {
                console.log(err);
                if( err.response.status == 500 ){
                    this.error = this.$t('all.error-500');
                  } else if( err.response.status == 404 ){
                    this.error = this.$t('all.error-404');
                  }
                this.search = false;
                this.loading = false;
            });
        } else {
             this.loading = false;
             this.search = false;
             this.searchResult = [];
        }
        },
        // addTwitter(user){
        //     // this.loading = true
        //     Swal.fire({
        //     title: this.$t('alert.alert-add')+user+' ?',
        //     showCancelButton: true,
        //     confirmButtonText: 'Save',
        //     confirmButtonColor: "#0067AC",
        //     }).then((result) => {
        //     if (result.isConfirmed) { 
        //           let data =  {
        //              "args": user
        //             }
        //           TwintService.getUser(data)
        //             .then( response => { 
        //                 var dataTwitter = response.data.output[0]
        //                 this.addNewTwitterData(dataTwitter)
        //             })
        //             .catch(err => {
        //             console.log(err);
        //         });
        //     } 
        //     })
        // },
        addTwitter(user){    
        Swal.showLoading()
           var today = new Date();
                var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                var dataSave = {
                "id_target" : '',
                "account" : user.screen_name,
                "user_id" : user.user_id,
                "name" : user.name,
                "avatar" : user.avatar,
                "followers" : user.followers,
                "following" : user.following,
                "tweets" : user.tweets,
                "favorites" : user.favorites,
                "likes" : user.favorites, // API baru menggunakan 'favorites' sebagai pengganti 'likes'
                "media" : user.media || 0, // field ini mungkin tidak ada di API baru
                "location" : user.location,
                "bio" : user.bio,
                "is_private" : user.private,
                "is_verified" : user.verified,
                "join_at" : user.created, // API baru menggunakan 'created' bukan 'created_at'
                "updated_at" : time
                }
                // console.log(dataSave);
               SocmedService.createTwitter(dataSave)
                    .then( response => {
                        // console.log(response)
                        if (response.status == 212) {    
                            Swal.fire('Twitter is Updated','', 'success');
                        } else {
                            Swal.fire(this.$t('alert.alert-save'), '', 'success') 
                        }
                    this.$router.push('/twitter')          
                })
                .catch(err => {
                console.log(err);
            });
        },
         formatDate(value){
            return moment(value).format("DD-MMM-YYYY");
        },
        formatDateSave(value){
            return moment(value).format("YYYY-MM-DD");
        },
        },
    mounted() {
        this.totalRows = this.items.length;
    },
};
</script>

<style scoped>
.card {
    border: 2px solid #f1f1f1;
}
</style>
